/*
 * @Author: Fan
 * @Date: 2020-04-18 21:23:13
 * @description:
 * @LastEditors: Fan
 */
import { inputControlOptions } from "../../../../form/component-schema";
import { DataType } from "../../../../form/typings";
import i18n from "../../../i18n";
export default {
    $id: "location",
    type: DataType.Object,
    $ref: inputControlOptions.$id,
    properties: {
        widgetType: {
            type: DataType.Number,
            title: i18n.t('dataitem.ControlType').toString(),
        },
        dataItemType: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemType').toString(),
        },
        range: {
            type: DataType.String,
            title: i18n.t('dataitem.PreciseRange').toString(),
        },
        displayMode: {
            type: DataType.String,
            title: i18n.t('dataitem.DisplayType').toString(),
            default: "accurate",
        },
        autoGetLocation: {
            type: DataType.String,
            title: i18n.t('dataitem.AutoLocation').toString(),
            default: "false",
        },
        defaultValue: {
            type: DataType.Object,
            title: i18n.t('dataitem.DefaultValue').toString(),
        },
        showSearch: {
            type: DataType.String,
            title: i18n.t('dataitem.LocationSearch').toString(),
        },
        labelVisible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.LabelVisible').toString(),
            default: true,
        },
        readonlyCondition: {
            type: DataType.String,
            title: i18n.t('dataitem.ReadonlyConditions').toString(),
        },
    },
};
